export class DetaliuCircuit
{
  public nrCrt: number;
  public companieId: string;
  public denumire: string;
  public cif: string;
}

